import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {

    let date = new Date();

  return <footer className='footer'>
      <p>Lima Hookah © {date.getFullYear()}</p>
      <Link className='footer_privacy_link' to='/privacy-policy'>Політика конфіденційності</Link>
  </footer>;
};

export default Footer;
